import { CardIssuePointsApi, HttpClient, Api } from '../../../api'
import {
  AddCardIssuePointOpts,
  CardIssuePoint,
  CardIssuePointFindOptions,
  CardIssuePointsService,
  UpdateCardIssuePointOpts,
} from './cardIssuePoints'
import { Context, Id, PaginatedResult, mapDtoToEntity } from '../../../common'

function mapDtoToCardIssuePoint(dto: Api.CardIssuePoint): CardIssuePoint {
  return mapDtoToEntity({
    ...dto,
    municipalEntityId: dto.municipalEntityId,
    number: dto.number,
    locality: dto.locality,
    windowsCount: dto.windowsCount,
    comment: dto.comment,
  })
}

export class RemoteCardIssuePointsService implements CardIssuePointsService {
  private api: CardIssuePointsApi

  constructor(httpClient: HttpClient) {
    this.api = new CardIssuePointsApi(httpClient, undefined, '')
  }

  async findAll(ctx: Context, opts?: CardIssuePointFindOptions | undefined): Promise<PaginatedResult<CardIssuePoint>> {
    const result = await this.api.cardIssuePointsGetList(ctx, {
      ids: opts?.filter?.ids,
      municipalEntityId: opts?.filter?.municipalEntityId,
      search: opts?.filter?.search,
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
      orderBy: opts?.order?.field,
      direction: opts?.order?.direction,
    })

    return {
      ...result.body,
      items: result.body.items.map(mapDtoToCardIssuePoint),
    }
  }
  async findById(ctx: Context, id: string): Promise<CardIssuePoint | undefined> {
    const result = await this.api.cardIssuePointsGetById(ctx, id)
    return mapDtoToCardIssuePoint(result.body.object)
  }

  async findByIdNonDeleted(ctx: Context, id: string): Promise<CardIssuePoint | undefined> {
    const result = await this.api.cardIssuePointsGetList(ctx, { ids: [id], count: 1 })
    return result.body.items.length > 0 ? mapDtoToCardIssuePoint(result.body.items[0]) : undefined
  }

  async add(ctx: Context, opts: AddCardIssuePointOpts): Promise<Id> {
    const result = await this.api.cardIssuePointsAdd(ctx, opts)
    return result.body.id
  }

  async update(ctx: Context, id: string, opts: UpdateCardIssuePointOpts): Promise<void> {
    await this.api.cardIssuePointsUpdate(ctx, id, opts)
  }

  async delete(ctx: Context, id: string): Promise<void> {
    await this.api.cardIssuePointsDelete(ctx, id)
  }
}
